import { render, staticRenderFns } from "./estadoCuenta.vue?vue&type=template&id=5560a097&"
import script from "./estadoCuenta.vue?vue&type=script&lang=js&"
export * from "./estadoCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports